import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { SportParameterizationRoutingModule } from "./sport-parameterization-routing.module";
import { SportParameterizationComponentList } from "./sport-parameterization-list/sport.parameterization-list.component";
import { SportParameterizationComponentForm } from "./sport-parameterization-form/sport.parameterization-form.component";

@NgModule({
  declarations: [
    SportParameterizationComponentList,
    SportParameterizationComponentForm,
    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SportParameterizationRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [
    SportParameterizationComponentForm
  ]
})
export class SportParameterizationModule { }
